<template>
  <div class="guideExclusiveData">
    <TableToolTemp :toolListProps="guideExclusiveDataTool" @handleTool="handleTool" />
    <!-- 搜索栏 -->
    <SearchForm
      :searchForm="initParam"
      :searchFormTemp="searchFormTemp"
      authBtn="bbc:guideExclusive:all"
      @normalSearch="normalSearch"
      @normalResetQuery="normalResetQuery"
    />
    <!-- 表格数据 -->
    <div class="mainWrap">
      <p class="tableTitle"><span>方案代码 </span>{{ planCode }}</p>
      <Table :data="tableData" :options="tableOptions" align='center'/>
      <Pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :pageData="initParam"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
import TableToolTemp from '@/components/layouts/TableToolTemp';
import SearchForm from '@/components/layouts/SearchForm';
import Pagination from '@/components/layouts/Pagination';
import Table from '@/components/layouts/table';
import { myMixin } from '@/mixins';
import $api from '@/api/guideExclusive';

export default {
  components: { TableToolTemp, SearchForm, Pagination, Table },
  mixins: [myMixin],
  data() {
    return {
      dicArr: ['bbc.payType', 'bbc.gender.MF', 'bbc.order.status','bbc.preservation.rela'],
      guideExclusiveDataTool: {
        toolTitle: '查询条件',
        toolList: [{ name: '导出', btnCode: '' }],
      },
      planCode: '',
      initParam: {
        pageNum: 1,
        pageSize: 10,
        param: { planCode: '', planName: '', name: '', identityCode: '', telephone: '', productSource: '',channel:'' },
      },
      searchFormTemp: [
        { lable: '方案名称', name: 'productPlanName', type: 'input' },
        { lable: '被保人姓名', name: 'name', type: 'input' },
        { lable: '证件号码', name: 'identityCode', type: 'input' },
        { lable: '手机号', name: 'telephone', type: 'input' },
        { lable: '保费', name: 'premium', type: 'input' },
        { lable: '订单状态', name: 'status', type: 'select', dic: 'bbc.order.status' },
      ],
      tableOptions: [
        { prop: 'planCode', label: '计划代码', width: 110 },
        { prop: 'planName', label: '计划名称', width: 180 },
        { prop: 'productPlanName', label: '方案名称', width: 240 },
        { prop: 'payCode', label: '订单号', width: 180 },
        { prop: 'empName', label: '员工姓名', width: 100 },
        { prop: 'name', label: '被保人姓名', width: 100 },
        { prop: 'identityCode', label: '身份证号', width: 165 },
        { prop: 'age', label: '年龄', width: 80 },
        { prop: 'gender', label: '性别', width: 80, dic: 'bbc.gender.MF' },
        { prop: 'relationWithStaff', label: '与员工关系', width: 100  ,dic: 'bbc.preservation.rela'},
        { prop: 'telephone', label: '手机号', width: 120 },
        { prop: 'email', label: '邮箱', width: 120 },
        { prop: 'personalPremium', label: '保费' },
        { prop: 'statusDesc', label: '支付状态' },
        { prop: 'payType', label: '支付方式', dic: 'bbc.payType' ,width: 150 },
        { prop: 'payTime', label: '支付时间' },
        { prop: 'payNo', label: '支付流水', width: 220 },
        { prop: 'refundTime', label: '退款时间' },
        { prop: 'refundNo', label: '退款流水', width: 220 },
      ],
      tableData: [],
      total: 0,
    };
  },
  methods: {
    init() {
      const { planCode } = this.$route.query;
      if (planCode) {
        this.planCode = planCode;
      }
      this.queryData();
    },
    async queryData(bool) {
      if (bool) this.initParam.pageNum = 1;
      const { planId } = this.$route.query;
      this.initParam.param.planId = planId;
      this.initParam.param.productSource = '';
      $api.InsuredPage(this.initParam).then((res) => {
        if (res.list) {
          this.tableData = res.list.map(item => {
            if (item.status === 3 && ['微信支付', '支付宝支付'].includes(item.payType)) {
              item.payType = '';
            }
            return item;
          });
        } else {
          this.tableData = [];
        }
        this.total = res.total;
      });
    },
    // 主标题功能按钮
    handleTool(obj) {
      if (obj.name === '导出') {
        if (!this.tableData.length) return this.$message.warning('暂无数据导出！');
        $api.InsuredExport('团险参保数据.xlsx', this.initParam.param);
      } else if (obj.name === '下载电子签名') {
        if (!this.tableData.length) return this.$message.warning('暂无电子签名下载！');
        // $api.DownloadSignExt({ planId: this.initParam.param.planId }).then(res => {
        //   if (res) {
        //     const reader = new FileReader();
        //     reader.readAsDataURL(res);
        //     reader.onload = e => {
        //       const a = document.createElement('a');
        //       a.download = `电子签名.zip`;
        //       a.href = e.target.result;
        //       document.body.appendChild(a);
        //       a.click();
        //       document.body.removeChild(a);
        //     };
        //   }
        // });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.guideExclusiveData {
  .tableTitle {
    padding: 10px 20px;
    font-size: 14px;
    span {
      font-weight: bold;
    }
  }
}
</style>
